/**
 * API Headers Configuration
 * These constants define the standard headers required by the backend API
 */

/**
 * Application code - 2 character code assigned to the application
 */
export const APP_CODE = 'XPAY';

/**
 * Caller name - Name of the API/application making the request
 */
export const CALLER_NAME = 'xpay-webapp-client';

/**
 * Session storage key for session UID
 */
export const SESSION_UID_KEY = 'xpay-session-uid';

/**
 * Session storage key for the X-Session token obtained from the security API after login
 */
export const SESSION_TOKEN_KEY = 'xpay-session-token';
